/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';


export interface ImportJsonTranslationsControllerGetJsonFileMultiple$Params {
  languageCode: string;

/**
 * Array of app identifiers to include in the translation
 */
  appIdentifier: Array<string>;
}

export function importJsonTranslationsControllerGetJsonFileMultiple(http: HttpClient, rootUrl: string, params: ImportJsonTranslationsControllerGetJsonFileMultiple$Params, context?: HttpContext): Observable<StrictHttpResponse<{
}>> {
  const rb = new RequestBuilder(rootUrl, importJsonTranslationsControllerGetJsonFileMultiple.PATH, 'get');
  if (params) {
    rb.path('languageCode', params.languageCode, {});
    rb.query('appIdentifier', params.appIdentifier, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<{
      }>;
    })
  );
}

importJsonTranslationsControllerGetJsonFileMultiple.PATH = '/import-json-translations/generate-translation-json-multiple/{languageCode}';
